if (typeof AddOnsSingleProductsStandalone !== 'function') {
    class AddOnsSingleProductsStandalone extends HTMLElement {
        constructor() {
            super();

            this.buttonHandleTooltip = this.querySelectorAll('[data-button-handle-tooltip]');
            this.buttonDismiss = this.querySelectorAll('[data-modal-dismiss]');
            this.optionButtons = this.querySelectorAll('[data-addons-product]');

            this._jsonCache = new Map();
            this._token = 0;

            const rootInput = document.getElementById('root_input');
            if (rootInput && !window.__standaloneOriginalRoot) {
                window.__standaloneOriginalRoot = {
                    value: rootInput.value,
                    seek: rootInput.getAttribute('data-seek')
                };
            }

            this.buttonHandleTooltip?.forEach(button => {
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const target = button.getAttribute('data-tooltip-target');
                    this.querySelector('#' + target)?.classList.add('show');
                });
            });

            this.buttonDismiss?.forEach(button => {
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const target = button.getAttribute('data-tooltip-target');
                    this.querySelector('#' + target)?.classList.remove('show');
                });
            });

            this.optionButtons?.forEach(button => {
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (button.getAttribute('data-available') === 'false') return;
                    if (button.classList.contains('active')) return;
                    this.selectTile(button);
                });
            });

            const self = this;
            document.addEventListener('change', function (e) {
                const t = e.target;
                if (!t || !t.matches) return;
                if (t.matches('input[type="radio"][name^="option"]') ||
                    t.matches('select[name^="option"]')) {
                    setTimeout(function () { self.syncActiveTile(); }, 50);
                }
            });

            setTimeout(function () { self.syncActiveTile(); }, 100);
            this.updatePriceFromRoot();
        }

        // Vraca true samo ako je ova instanca vidljiva (nije sakrivena CSS-om za mobile/desktop).
        // Sprjecava da skrivena instanca prepisuje root_input.
        isVisible() {
            if (this.offsetParent === null) {
                const style = window.getComputedStyle(this);
                if (style.position !== 'fixed') return false;
            }
            const rect = this.getBoundingClientRect();
            if (rect.width === 0 && rect.height === 0) return false;
            return true;
        }

        getSelectedOptions() {
            const picker = document.querySelector('variant-picker');
            const root = picker || document;
            const inputs = root.querySelectorAll('input[type="radio"][name^="option"]:checked');
            const map = {};
            inputs.forEach(function (i) { map[i.name] = i.value; });
            const sortedNames = Object.keys(map).sort(function (a, b) {
                return parseInt(a.replace('option', ''), 10) - parseInt(b.replace('option', ''), 10);
            });
            return sortedNames.map(function (n) { return map[n]; });
        }

        fetchProductJson(handle) {
            if (!handle) return Promise.resolve(null);
            if (this._jsonCache.has(handle)) return this._jsonCache.get(handle);
            const promise = fetch('/products/' + handle + '.js', {
                headers: { 'Accept': 'application/json' }
            })
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; });
            this._jsonCache.set(handle, promise);
            return promise;
        }

        resolveBundleVariant(button) {
            const self = this;
            const fallback = {
                id: button.getAttribute('data-value'),
                price: button.getAttribute('data-seek')
            };
            const handle = button.getAttribute('data-product-handle');
            if (!handle) return Promise.resolve(fallback);

            return this.fetchProductJson(handle).then(function (json) {
                if (!json || !Array.isArray(json.variants) || !json.variants.length) {
                    return fallback;
                }
                const selected = self.getSelectedOptions();
                if (!selected.length) return fallback;

                const norm = function (s) { return String(s || '').trim().toLowerCase(); };
                const target = selected.map(norm);

                let match = json.variants.find(function (v) {
                    const opts = (v.options || []).map(norm);
                    if (opts.length !== target.length) return false;
                    return target.every(function (val, idx) { return opts[idx] === val; });
                });

                if (!match) {
                    const colorVal = target[target.length - 1];
                    match = json.variants.find(function (v) {
                        return (v.options || []).map(norm).indexOf(colorVal) !== -1;
                    });
                }

                if (!match) {
                    match = json.variants.find(function (v) { return v.available; }) || json.variants[0];
                }

                if (!match) return fallback;

                return {
                    id: String(match.id),
                    price: String(match.price)
                };
            });
        }

        getMainSelectedVariantId() {
            const allIdInputs = document.querySelectorAll('input[name="id"]:not(#root_input), select[name="id"]:not(#root_input)');
            for (let i = 0; i < allIdInputs.length; i++) {
                const inp = allIdInputs[i];
                if (inp.closest('addon-single-product-standalone, addon-single-product')) continue;
                if (inp.value) return inp.value;
            }
            try {
                const v = new URL(location.href).searchParams.get('variant');
                if (v) return v;
            } catch (e) {}
            return window.__standaloneOriginalRoot ? window.__standaloneOriginalRoot.value : null;
        }

        selectTile(button) {
            this.optionButtons.forEach(function (ele) { ele.classList.remove('active'); });
            button.classList.add('active');
            this.syncActiveTile();
        }

        syncActiveTile() {
            if (!this.isVisible()) return;

            const activeBtn = this.querySelector('[data-addons-product].active');
            if (!activeBtn) return;

            const rootInput = document.getElementById('root_input');
            if (!rootInput) return;

            const isBundle = !!activeBtn.getAttribute('data-value');
            const self = this;

            this._token++;
            const myToken = this._token;

            if (!isBundle) {
                const mainId = this.getMainSelectedVariantId();
                if (mainId) {
                    rootInput.value = mainId;
                    if (window.__standaloneOriginalRoot && window.__standaloneOriginalRoot.seek) {
                        rootInput.setAttribute('data-seek', window.__standaloneOriginalRoot.seek);
                    }
                }
                this.updatePriceFromRoot();
            } else {
                this.resolveBundleVariant(activeBtn).then(function (resolved) {
                    if (myToken !== self._token) return;
                    if (!activeBtn.classList.contains('active')) return;
                    if (!self.isVisible()) return;
                    if (resolved && resolved.id) {
                        rootInput.value = resolved.id;
                        if (resolved.price) rootInput.setAttribute('data-seek', resolved.price);
                        activeBtn.setAttribute('data-value', resolved.id);
                        if (resolved.price) activeBtn.setAttribute('data-seek', resolved.price);
                    }
                    self.updatePriceFromRoot();
                });
            }
        }

        updatePriceFromRoot() {
            const rootInput = document.getElementById('root_input');
            if (!rootInput) return;

            const total = Number(rootInput.getAttribute('data-seek')) || 0;
            const formatted = (total / 100).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
            });

            document.querySelectorAll('.total_buy_button').forEach(function (btn) {
                btn.innerHTML = formatted;
            });
            const totalBuy = document.getElementById('total_buy');
            if (totalBuy) totalBuy.innerHTML = formatted;
        }
    }

    if (typeof customElements.get('addon-single-product-standalone') === 'undefined') {
        customElements.define('addon-single-product-standalone', AddOnsSingleProductsStandalone);
    }
}
